import { defineComponent as _defineComponent } from 'vue';
import Dialog from "@/components/common/dialog/Dialog.vue";
import Button from "@/components/ui/button/Button.vue";
import Checkbox from "@/components/ui/Checkbox.vue";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ObjectiveAssignmentDialog',
    props: {
        availableObjectives: { type: Array, required: true, default: () => [] },
        assignedObjectiveIds: { type: Array, required: true, default: () => [] }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const dialogRef = ref();
        const selectedIds = ref([]);
        const open = () => {
            var _a;
            // Initialize with currently assigned objective IDs
            selectedIds.value = [...props.assignedObjectiveIds];
            return ((_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.open()) || Promise.resolve({ action: "close" });
        };
        const handleSubmit = () => {
            var _a;
            (_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.accept(selectedIds.value);
        };
        const handleCancel = () => {
            var _a;
            (_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.cancel();
        };
        __expose({
            open,
        });
        const __returned__ = { props, dialogRef, selectedIds, open, handleSubmit, handleCancel, Dialog, Button, Checkbox };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
